<template>
  <div class="personal-home">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
      <div style="font-weight: bold;font-size: 20px;color: #333333;">{{ $t('personal.my_order') }}</div>
      <div>
        <el-button :class="menuIndex === 0 ? 'select-btn' : 'btn'" @click="changeMenu(0)">
            {{ $t('personal.pending_payment') }}
          </el-button>
          <el-button :class="menuIndex === 1 ? 'select-btn' : 'btn'" @click="changeMenu(1)">
            {{ $t('personal.paid') }}
          </el-button>
        <!-- <el-button @click="changeMenu(0)" :color="menuIndex === 0 ? '#2371FF' : '#fff'" :text="menuIndex != 0"
          :bg="menuIndex != 0">
          待支付
        </el-button>
        <el-button style="margin-left: 10px;" @click="changeMenu(10)"
          :color="menuIndex === 10 ? '#2371FF' : '#fff'" :text="menuIndex != 10" :bg="menuIndex != 10">
          已支付
        </el-button> -->
      </div>
    </div>
    <div :infinite-scroll-immediate="false" v-infinite-scroll="initList"
      style="position: absolute; top:80px; left:20px; right: 20px; bottom: 20px; overflow-y: auto;">
      <div v-if="orderList.length == 0">
        <el-empty :description="$t('personal.no_data')" />
      </div>
      <div v-for="(item, index) of orderList" v-bind:key="index" @click="onOrderItem(item)"
        style="border: 1px solid #ccc;border-radius: 4px;padding: 20px;margin-bottom: 20px; cursor: pointer;">
        <div style="display: flex;flex-direction: column;width: 100%">
          <div style="display: flex;justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <div style="font-size: 16px;color: #333;font-weight: bold; margin-top: 4px;">{{ item.orderNo }}</div>
            <div v-if="item.orderStatus === 0"
              style="font-size: 14px; color: #333333; display: flex;align-items: center;">
              <div>{{ $t('personal.remaining_payment_time') }}</div>
              <el-countdown format="HH:mm:ss" :value="getEndTime(item.expireTime)" />
            </div>
          </div>
          <div>
            <div style="display: flex;justify-content: space-between;align-items: flex-end;margin-top: 10px">
              <div style="display: flex">
                <div
                  style="width: 100px;height: 100px;background-color: #E8EAED; position: relative; display: flex; justify-content: center; align-items: center;">
                  <img v-if="item.designImageDtoList && item.designImageDtoList.length > 0" style="width: 100%"
                    :src="item.designImageDtoList[0].previewUrl">
                  <img v-else style="max-width: 100%; max-height: 100%; width: auto; height: auto;"
                    :src="item.orderItems[0].itemFileUrl[0]" alt="">

                  <!-- <img :src="item.designImageDtoList[0].artUrl"
                    style="width: 40px; position: absolute; left: 50%; transform: translate(-50%,-50%); top:50%;"
                    alt=""> -->
                </div>
                <div
                  style="margin-left: 20px;color: #333;font-size: 18px;display: flex;flex-direction: column;justify-content: space-between">
                  <div style="font-size: 16px">{{ item.customDesignName }}</div>
                  <div style="font-size: 14px;color: #666;display: flex;align-items: center">
                    <div>{{ item.orderItems[0].itemName }}</div>
                    <!-- <div>{{ getProperties(item.orderItems[1].itemProperties, 1)?.specValue || '未知' }}</div>
                    <div style="width: 1px;height: 10px;background: #CCCCCC; margin-left: 10px; margin-right: 10px;">
                    </div> -->
                    <!-- <div>{{ getProperties(item.orderItems[1].itemProperties, 0)?.specName ||
                      '未知' }}</div> -->
                    <!-- <div>{{ item.orderItems[0].itemProperties }}</div> -->
                  </div>
                  <div style="font-size: 14px;color: #666;display: flex;align-items: center">
                    <div>{{ $t('personal.quantity') }}</div>
                    <div>{{ item.orderItems[0].itemQuantity }}</div>
                  </div>
                </div>
              </div>
              <div class="price">¥{{ item.totalAmount }}</div>
            </div>
            <!-- <div style="display: flex;justify-content: space-between;align-items: flex-end;margin-top: 20px">
              <div style="display: flex">
                <div style="width: 100px;height: 100px;background-color: #E8EAED">
                  <img style="width: 100%" :src="item.orderItems[0].itemFileUrl[0]">
                </div>
                <div
                  style="margin-left: 20px;color: #333;font-size: 16px;display: flex;flex-direction: column;justify-content: space-between">
                  <div>{{ item.orderItems[0].itemName }}</div>
                  <div style="font-size: 14px;color: #666;display: flex;align-items: center">
                    <div>{{ $t('personal.quantity') }}</div>
                    <div>{{ item.orderItems[0].itemQuantity }}</div>
                  </div>
                </div>
              </div>
              <div style="font-size: 18px;color: #333;font-weight: 400">¥{{ item.orderItems[0].itemPrice }}</div>
            </div> -->

            <!--            <div style="display: flex;flex-direction: column;justify-content: space-between">-->
            <!--              <div style="display: flex;flex-direction: column;align-items: end">-->
            <!--                <div class="price">123.4</div>-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                <el-button color="#2371FF" round>支付</el-button>-->
            <!--                <el-button  round style="margin-left: 20px">取消订单</el-button>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div style="display: flex;justify-content: flex-end;align-items: center; margin-top: 20px;">
            <div v-if="item.orderStatus === 0">
              <el-button style="width: 100px;height: 36px;" @click.stop="cancelOrder(item)">{{ $t('personal.cancel_order') }}</el-button>
              <el-button @click.stop="pay(item)" color="#020468"
                style="margin-left: 10px;width: 100px;height: 36px;">{{ $t('personal.pay') }}</el-button>
            </div>
            <div v-else></div>
            <!-- <div class="price">¥{{ item.totalAmount }}</div> -->
          </div>
        </div>
      </div>
    </div>

    <!--      <div  v-for="(item, index) of orderList" v-bind:key="index" shadow="hover">-->
    <!--        <div class="box-card">-->
    <!--          <div style="display: flex;">-->
    <!--            <div style="width: 180px;height: 180px;background-color: #E8EAED">-->
    <!--              <img style="width: 100%" :src="item.designFileUrl">-->
    <!--            </div>-->
    <!--            <div style="margin-left: 20px;color: #333;font-size: 18px;display: flex;flex-direction: column;justify-content: space-between">-->
    <!--              <div>{{item.orderNo}}</div>-->
    <!--              <div>{{item.customDesignName|| '无'}}</div>-->
    <!--              <div>颜色：白  尺寸：XL</div>-->
    <!--              <div>数量：{{item.quantity}}</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div style="display: flex;flex-direction: column;justify-content: space-between">-->
    <!--            <div style="display: flex;flex-direction: column;align-items: end">-->
    <!--              <div class="price">123.4</div>-->
    <!--              <div>剩余时间：23:33</div>-->
    <!--            </div>-->
    <!--            <div>-->
    <!--              <el-button color="#2371FF" round>支付</el-button>-->
    <!--              <el-button  round style="margin-left: 20px">取消订单</el-button>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <el-divider v-if="index !== 10" />-->
    <!--      </div>-->
    <!-- <div v-if="total > 0" style="height: 40px; margin-bottom: 20px; display: flex; justify-content:center;">
      <el-pagination background layout="prev, pager, next" :current-page="searchParams.pageNum"
        :page-size="searchParams.pageSize" :total="total" @current-change="handCurrentChange" />
    </div> -->
    <order-detail ref="orderDetailRef" @cancelOrder="onCancelOrder"></order-detail>
  </div>
</template>

<script>

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { getAliPay, getAliPayState, getHeartList, getOrderList, cancelOrderById } from "@/api/api";
import router from "@/router";
import { ElMessage } from "element-plus";
import { useI18n } from 'vue-i18n';
import orderDetail from "./order-detail.vue";
export default {
  name: 'PersonalIndex',
  components: {
    orderDetail
  },
  props: {
    orderTabIndex: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const menuIndex = ref(props.orderTabIndex)
    // 监听 props 中的 orderTabIndex 变化
    watch(() => props.orderTabIndex, (newVal) => {
      if (!isNaN(newVal)) {
        ElMessage.success(t('personal.payment_success'))
        menuIndex.value = newVal;
        searchParams.value.orderStatus = newVal;
        orderList.value = [];
        searchParams.value.pageNum = 1;
        searchParams.value.isEnd = false;
        initList();
      }
    });
    onMounted(() => {
      console.log(props, 'props')
      initList()
    })

    const changeMenu = (index) => {
      menuIndex.value = index
      searchParams.value.orderStatus = index
      orderList.value = []
      searchParams.value.pageNum = 1
      searchParams.value.isEnd = false
      initList()
    }

    const orderDetailRef = ref(false)
    const onOrderItem = (item) => {
      orderDetailRef.value.show(item)
    }
    const orderList = ref([])
    const searchParams = ref({
      pageNum: 1,
      pageSize: 10,
      orderStatus: 0,
      isEnd: false
    })
    const total = ref(0)
    const initList = () => {
      if (!searchParams.value.isEnd) {
        getOrderList(searchParams.value).then(res => {
          searchParams.value.pageNum += 1
          // 将价格字段从 "分" 转换为 "元"
          const formattedRecords = res.records.map(order => {
            return {
              ...order,
              totalAmount: (order.totalAmount / 100).toFixed(2),
              orderItems: order.orderItems.map(item => ({
                ...item,
                itemPrice: (item.itemPrice / 100).toFixed(2)
              }))
            };
          });
          for (let a of formattedRecords) {
            a.orderItems = a.orderItems.filter(a => a.itemType == 1)
          }
          orderList.value = orderList.value.concat(formattedRecords);
          if (res.records.length < searchParams.value.pageSize) {
            searchParams.value.isEnd = true
          }
        });
      }
    };
    const getProperties = (properties, index) => {
      const json = JSON.parse(properties)
      if (json.length > index) {
        // console.log(json[index].specName)
        return json[index]
      }
    }
    const getEndTime = (time) => {
      return new Date(time).getTime()
    }

    const payCallBackTime = ref(null)
    // watch(isShow, (newValue, oldValue) => {
    //   if (!newValue) {
    //     if (payCallBackTime.value) {
    //       clearInterval(payCallBackTime.value)
    //     }
    //   }
    // })

    // 在组件卸载前关闭定时器
    onBeforeUnmount(() => {
      if (payCallBackTime.value) {
        clearInterval(payCallBackTime.value);
        payCallBackTime.value = null; // 避免重复清除
      }
    });

    const cancelOrder = (item) => {
      cancelOrderById(item).then(res => {
        ElMessage.success(t('personal.operation_success'))
        changeMenu(0)
        emit("cancelOrder")
      })
    }

    const onCancelOrder = () => {
      changeMenu(0)
      emit("cancelOrder")
    }

    const pay = (res) => {
      getAliPay({
        orderNo: res.orderNo
      }).then(res => {
        const div = document.createElement('div')
        div.innerHTML = res.payBody
        document.body.appendChild(div)
        // document.forms[0].target = '_blank'
        document.forms[0].submit()
        div.innerHTML = ''
      }).catch(err => { })

      //循环查询订单支付状态
      payCallBackTime.value = setInterval(() => {
        getAliPayState({ orderNo: res.orderNo }).then((res) => {
          console.log(res)
          if (res.payStatus === 20) {
            console.log(t('personal.payment_success'))
            clearInterval(payCallBackTime.value)
            router.push({ path: `/` });
            ElMessage.success(t('personal.payment_success'));
          } else if (res.payStatus === 50) {
            console.log('已退款')
            clearInterval(payCallBackTime.value)
            router.push({ path: `/` });
          }
        });
      }, 2000)
    }

    const handCurrentChange = (val) => {
      searchParams.value.pageNum = val
      initList()
    }
    return {
      onCancelOrder,
      onOrderItem,
      cancelOrder,
      searchParams,
      handCurrentChange,
      total,
      pay,
      getEndTime,
      getProperties,
      orderList,
      initList,
      changeMenu,
      menuIndex,
      orderDetailRef
    }
  }
}

</script>
<style scoped>
:deep(.el-statistic__content) {
  font-size: 14px;
}

:deep(.el-statistic__number) {
  color: #FE0808;
}

.btn {
  width: 86px;
  height: 42px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  border: none;
}

.select-btn {
  width: 86px;
  height: 42px;
  border: 1px solid #1358BF;
  font-weight: 400;
  font-size: 16px;
  color: #1358BF;
}

.personal-home {
  /* margin: 20px; */
}

:deep(.el-card__body) {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.price {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #FF0E0E;
}

.box-card {
  margin-top: 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  width: 912px;
  border-radius: 20px;
}
</style>
